import { BrowserRouter, Route, Routes, useLocation, useOutletContext } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css"

import Layout from './Layout/Layout';
import Dashboard from './Pages/Dashboard';
import PluginAdmin from './Pages/PluginAdmin';
// import News from './Pages/News';
import CyberLog from './Pages/CyberLog';
import Compliance from './Pages/Compliance';
import MyAssets from './Pages/MyAssets';
import Login from './Pages/Login';
import Networking from './Pages/Lead/Networking';
import PrivateRoute from './Components/PrivateRoute';
import CompanyForm from './Components/Form/CompanyForm';
import Questionario from './Pages/Questionario';
import QuestionarioReview from './Pages/QuestionarioReview';
import QuestionarioView from './Pages/QuestionarioView';
import TestPage from './Pages/TestPage';
import Profilo from './Pages/Profilo';
import CyberSurveillance from './Pages/CyberSurveillance';
import ActivatePage from './Pages/ActivatePage';
import AssetVerifyPage from './Pages/AssetVerifyPage';
import SetFirstPassword from './Pages/SetFirstPassword';
import ChangePassword from './Pages/ChangePassword';
import SsoInterceptor from './Components/SsoInterceptor';
// import ChatWidget from './Components/Chatbox/ChatWidget';
import EnterpriseConsent from './Pages/EnterpiseConsent'
import { useRecoilValue } from 'recoil';
import { disableForEnterpriseAtom } from './Atom/disableForEnterpriseAtom';
import NotFound from "./Pages/NotFound"
import Awareness from './Pages/Awareness';
import AwarenessRoute from './Components/AwarenessRoute';
import StoreOrderPage from './Pages/store/StoreOrderPage';
import StoreOrderConfirmPage from './Pages/store/StoreOrderConfirmPage';
import StripeSuccessPage from './Pages/store/StripeSuccessPage';
import StripeCancelPage from './Pages/store/StripeCancelPage';
import MFASetup from './Pages/MFASetup';
import MieiOrdini from './Pages/MieiOrdini';
import { memo } from 'react';



const pageVariants = {
  none: {},
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
  slide: {
    initial: { x: 100, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -100, opacity: 0 },
  },
  slideUp: {
    initial: { y: 100, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -100, opacity: 0 },
  },
  fadeLeft: {
    initial: { x: -100, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -100, opacity: 0 },
  },
  fadeRight: {
    initial: { x: 100, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: 100, opacity: 0 },
  },
  fadeUp: {
    initial: { y: -100, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -100, opacity: 0 },
  },
  fadeDown: {
    initial: { y: 100, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 100, opacity: 0 },
  },
  zoom: {
    initial: { scale: 0.8, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.8, opacity: 0 },
  },
  rotate: {
    initial: { rotate: -10, opacity: 0 },
    animate: { rotate: 0, opacity: 1 },
    exit: { rotate: 10, opacity: 0 },
  },
  flip: {
    initial: { rotateY: 90, opacity: 0 },
    animate: { rotateY: 0, opacity: 1 },
    exit: { rotateY: -90, opacity: 0 },
  },
  skew: {
    initial: { skewX: '45deg', opacity: 0 },
    animate: { skewX: '0deg', opacity: 1 },
    exit: { skewX: '-45deg', opacity: 0 },
  },
  bounce: {
    initial: { y: 50, scale: 0.9, opacity: 0 },
    animate: {
      y: [50, -10, 0],
      scale: [0.9, 1.05, 1],
      opacity: 1,
    },
    exit: { opacity: 0, scale: 0.9 },
  },
  spring: {
    initial: { scale: 0.8, opacity: 0 },
    animate: {
      scale: 1,
      opacity: 1,
      transition: { type: 'spring', stiffness: 120, damping: 14 }
    },
    exit: { scale: 0.8, opacity: 0 },
  },
};

// Wrapper che applica le animazioni di entrata/uscita
const PageWrapper = ({ children, variant = 'fadeLeft' }) => {
  const v = pageVariants[variant];
  return (
    <motion.main
      initial={v.initial}
      animate={v.animate}
      exit={v.exit}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
      style={{ flex: 1 }}
    >
      {children}
    </motion.main>
  );
};

// Route component per le pagine protette con animazioni
function AnimatedRoutes({ disableForEnterprise }) {
  const location = useLocation();
  const { orderData, orderLoading } = useOutletContext();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>

        {/* Rotte sempre accessibili */}
        <Route path="dashboard" element={<PageWrapper><Dashboard /></PageWrapper>} />
        <Route path="ordini" element={<PageWrapper><MieiOrdini /></PageWrapper>} />
        <Route path="cyberlog" element={<PageWrapper><CyberLog /></PageWrapper>} />
        <Route path="cybersurveillance" element={<PageWrapper><CyberSurveillance /></PageWrapper>} />
        <Route path="networking" element={<PageWrapper><Networking /></PageWrapper>} />
        <Route path="awareness" element={<PageWrapper><AwarenessRoute orderData={orderData} orderLoading={orderLoading}><Awareness /></AwarenessRoute></PageWrapper>} />

        {/* Rotte disabilitabili */}
        {disableForEnterprise === false ?
          <>
            <Route path="pluginadmin" element={<PageWrapper><PluginAdmin /></PageWrapper>} />
            <Route path="compliance" element={<PageWrapper><Compliance /></PageWrapper>} />
            <Route path="myassets" element={<PageWrapper><MyAssets /></PageWrapper>} />
            <Route path="enterpriseConsent" element={<PageWrapper><EnterpriseConsent /></PageWrapper>} />
          </> :
          null
        }

        <Route path="mfa-setup" element={<PageWrapper><MFASetup /></PageWrapper>} />

         <Route path="*" element={<PageWrapper><NotFound /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
}


export default memo(function App() {
  const disableForEnterprise = useRecoilValue(disableForEnterpriseAtom);

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>

        {/* Rotta pubblica */}
        <Route path="/" element={<Login />} />
        <Route path="/activate/:token" element={<ActivatePage />} />
        <Route path="/assets/verify/:token" element={<AssetVerifyPage />} />
        <Route path="/reset-password/:token" element={<SetFirstPassword />} />
        <Route path="/sso" element={<SsoInterceptor/>} />
        <Route path="/testpage" element={<TestPage />} />

        {/* Rotte pubbliche Store */}
        <Route path="/store/ordine" element={<StoreOrderPage />} />
        <Route path="/store/conferma" element={<StoreOrderConfirmPage />} />
        <Route path="/ordine-confermato" element={<StripeSuccessPage />} />
        <Route path="/ordine-annullato" element={<StripeCancelPage />} />


        {/* Rotte protette: Layout + animazioni */}
        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/*" element={<AnimatedRoutes disableForEnterprise={disableForEnterprise} />} />
        </Route>

        <Route path="/companyForm/:id" element={<PrivateRoute><CompanyForm /></PrivateRoute>} />
        <Route path="/questionario/:id" element={<PrivateRoute><Questionario /></PrivateRoute>} />
        <Route path="/questionario/:id/review" element={<PrivateRoute><QuestionarioReview /></PrivateRoute>} />
        <Route path="/questionario/:id/view" element={<PrivateRoute><QuestionarioView /></PrivateRoute>} />
        <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
        <Route path="/profilo" element={<PrivateRoute><Profilo /></PrivateRoute>} />
        
      </Routes>
      
    </BrowserRouter>
  );
});
